import compose from 'recompose/compose';
import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import { withRouter } from 'react-router';
import ChairRentalList from '../components/ChairRentalList';
import { getAllChairRentals } from '../selector';
import { getAllShopBarbersChairRental } from '../actions';
import { getShop, activeShop } from '../../../../auth/selectors';
import { canUseChairRental } from '../../../../common/helpers/users';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../../modules/infra/feature-flags';

const mapStateToProps = (state, ownProps) => ({
  chairRentals: getAllChairRentals(state),
  shop: getShop(state),
  chairRentalEnabled: canUseChairRental(activeShop(state), ownProps[flagNames.HYBRID_EXPOSE_RENT_COLLECT]),
});

const mapDispatchToProps = {
  getAllShopBarbersChairRental,
};

const ChairRentalListContainer = compose(
  withRouter,
  withInjectFeatureFlagsToProps([flagNames.HYBRID_EXPOSE_RENT_COLLECT]),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (!this.props.chairRentalEnabled) {
        return this.props.router.push('/barbers');
      }
      return this.props.getAllShopBarbersChairRental(this.props.shop);
    },
  })
)(ChairRentalList);

export default ChairRentalListContainer;
